import { cardInfo } from "App";
import SideCardBack from "components/SideCardBack";
import React, { useState } from "react";
import { GameState, Player } from "types";
import { ascRank, ascSuit } from "helper/functions";
import CardEast from "./CardEast";
import Plaque from "./Plaque";

interface Props {
  players: { [clientId: string]: Player };
  host: string;
  clientId: string;
  gameState: GameState;
  users: any;
  spectator?: boolean;
}

const cardSpacing = (n: number) =>
  n > 5 ? (0.5 - (5.25 * (n - 5)) / n) / 2 : 0.25;
const East: React.FC<Props> = ({
  players,
  clientId,
  gameState,
  users,
  spectator,
}) => {
  const [showCards, setShowCards] = useState((spectator || false) && false);
  const n = players[clientId].cards.length;
  return (
    <div className="py-2 flex items-center space-x-2 h-96 -mr-14 md:mr-2">
      <Plaque
        clientId={clientId}
        gameState={gameState}
        users={users}
        spectator={!!spectator}
        showCards={showCards}
        setShowCards={setShowCards}
        textRight
      />
      <div
        className={`flex flex-col justify-center py-2 rounded-xl transform ${
          clientId === gameState.currentPlayer
            ? "bg-green-400"
            : gameState.players[clientId].pass
            ? "bg-gray-400"
            : ""
        }`}
      >
        {players[clientId].cards.length !== 0 ? (
          players[clientId].cards
            .sort(ascSuit)
            .sort(ascRank)
            .map((card, i) => (
              <div
                style={{
                  marginBottom: `${
                    (i === n - 1 ? 0 : cardSpacing(n)) + 0.25
                  }rem`,
                  marginTop: `${(i === 0 ? 0 : cardSpacing(n)) + 0.25}rem`,
                }}
                className={``}
                key={`${cardInfo[card].rank}${cardInfo[card].suit}`}
              >
                {spectator && showCards ? (
                  <CardEast
                    small
                    dragging={false}
                    rank={cardInfo[card].rank}
                    suit={cardInfo[card].suit}
                  />
                ) : (
                  <SideCardBack
                    small
                    dragging={false}
                    rank={cardInfo[card].rank}
                    suit={cardInfo[card].suit}
                  />
                )}
              </div>
            ))
        ) : (
          <div
            className="flex justify-center items-center p-2 bg-gray-200"
            style={{ width: "5.6rem" }}
          >
            <div style={{ width: "5.6rem" }}>No cards remaining</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default East;
